import { ConnectionAuthKind } from 'shell-models-lib';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { BitbucketLinkedService } from 'app/model/linkedservice/bitbucket.linkedservice';
import { BitbucketCopySource } from 'app/model/pipeline/copysource/bitbucket.copysource';
import { GlobalVariables } from 'app/services/globals';

export const bitbucketMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(BitbucketLinkedService).name,
    displayName: 'Bitbucket',
    disabled: !GlobalVariables.enableBitbucketConnector,
    supportedInTrident: GlobalVariables.enableBitbucketConnector,
    supportAutoFillCopilotInput: GlobalVariables.enableBitbucketConnector,
    isKnownInPipelineContext: GlobalVariables.enableBitbucketConnector,
    supportedAuthKindsInTrident: [ConnectionAuthKind.Key],
    supportCopyJobSource: GlobalVariables.enableBitbucketConnector,
    supportOPDG: GlobalVariables.enableBitbucketConnector && GlobalVariables.enableOPDG,
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'Bitbucket' as ResourceKind
    },
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-REST'
    },
    isFirstClass: true,
    supportDatasetV2: true,
    supportFirstClassParameterExperience: true,
    category: ['ServicesApps'],
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(BitbucketCopySource).name]
};
